import config from '../plus/config'

// 封装一些全局元素。如全站通用功能函数和http请求等
export const global = {
  /**
   * 切换主题函数
   */
  changeTheme (themeValue) {
    const loadCss = (path) => {
      const head = document.getElementsByTagName('head')[0]
      const link = document.createElement('link')
      link.href = path
      link.rel = 'stylesheet'
      link.type = 'text/css'
      head.appendChild(link)
    }

    loadCss(`${config.CDN_HOST}/super/admin/css/${themeValue.toLowerCase()}.css`)

    localStorage.setItem('themeValue', themeValue)
  }
}

